import { generateClient } from "aws-amplify/api";
import { devicesByLocationID, deviceDataByDeviceID, listAiAnalizeData } from "../../graphql/queries";
import { AiAnalizeData, Device, DeviceData } from '../../API'
import { get } from 'aws-amplify/api';

const client = generateClient()

export const getDevices = async (locationID: string) => {
    const allDevices = await client.graphql({
        query: devicesByLocationID, variables: { locationID }
    });
    return allDevices.data.devicesByLocationID.items as unknown as Device[];
};

export const getDeviceDataByDeviceID = async (deviceID: string) => {
    const devicesData = await client.graphql({
        query: deviceDataByDeviceID, variables: { deviceID }
    });
    return devicesData.data.deviceDataByDeviceID.items as unknown as DeviceData[];
};

export const getDeviceData = async (deviceID: string, startDate: number, endDate: number) => {
    let allDevices = []
    let result = undefined
    let nextToken = null;

    do {
        result = await client.graphql({
            query: deviceDataByDeviceID, variables: { deviceID, filter: { data_start_timestamp: { gt: startDate.toString() }, data_end_timestamp: { lt: endDate.toString() } } }
        });
        nextToken = result.data.deviceDataByDeviceID.nextToken;
        allDevices = allDevices.concat(result.data.deviceDataByDeviceID.items)
    } while (nextToken)
    return allDevices as DeviceData[];
};

export const getDeviceDataTimeStamp = async (deviceID: string, startDate: number, endDate: number) => {
    let allDevices = []
    let result = undefined
    let nextToken = null;

    do {
        result = await client.graphql({
            query: deviceDataByDeviceID, variables: { deviceID, nextToken, filter: { timestamp: { lt: endDate.toString(), gt: startDate.toString() } } }
        });
        nextToken = result.data.deviceDataByDeviceID.nextToken;
        allDevices = allDevices.concat(result.data.deviceDataByDeviceID.items)
    } while (nextToken)
    return allDevices as DeviceData[];
};

export const getAiAnalizeData = async (deviceID: string, startDate: number, endDate: number) => {
    let allDevices = []
    let result = undefined
    let nextToken = null;

    do {
        result = await client.graphql({
            query: listAiAnalizeData, variables: { nextToken, filter: { deviceID: { eq: deviceID }, timestamp: { lt: endDate.toString(), gt: startDate.toString() } } }
        });
        nextToken = result.data.listAiAnalizeData.nextToken;
        allDevices = allDevices.concat(result.data.listAiAnalizeData.items)
    } while (nextToken)
    return allDevices as AiAnalizeData[];
};

export const getDeviceDataItems = async (deviceID: string, startDate: number, endDate: number) => {

    try {
        const restOperation = get({
            apiName: 'DeviceDataItemApi',
            path: '/deviceDataItems',
            options: {
                queryParams: {
                    startDate: startDate.toString(), // Konwertuj liczby na stringi
                    endDate: endDate.toString(),
                    deviceID: deviceID
                },
            }
        });
        const response = await restOperation.response;
        return response.body.json() as unknown as DeviceData[];
    } catch (e) {
        console.log('GET call failed: ', JSON.parse(e.response.body));
    }
}

export const getAiDeviceDataItems = async (deviceID: string, startDate: number, endDate: number) => {

    try {
        const restOperation = get({
            apiName: 'AiDeviceDataItemApi',
            path: '/deviceAiDataItems',
            options: {
                queryParams: {
                    startDate: startDate.toString(), // Konwertuj liczby na stringi
                    endDate: endDate.toString(),
                    deviceID: deviceID
                },
            }
        });
        const response = await restOperation.response;
        return response.body.json() as unknown as AiAnalizeData[];
    } catch (e) {
        console.log('GET call failed: ', JSON.parse(e.response.body));
    }
}